import React, { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormDatePicker, FormDropDownList, FormSwitch, FormInput, FormNumericTextBox } from "../components/formComponents";
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { GetPermissions } from '../components/Options';
import { Button } from '@progress/kendo-react-buttons';
import { TextBox } from '@progress/kendo-react-inputs';
import { Upload } from '@progress/kendo-react-upload';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from '@progress/kendo-react-labels';
import DataGrid from '../components/DataGrid';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import { Induction } from '../WeighBridge/Induction';
import ExpansionPanel from "../components/ExpansionPanel";

const CommandCell = (props) => {
    const { dataItem } = props;
    return (
        <td>
            <Button icon="arrow-up" onClick={() => props.moveUp(dataItem)} title="Save" />
            <Button icon="arrow-down" onClick={() => props.moveDown(dataItem)} title="Move Down" />
            <Button icon="edit" onClick={() => props.edit(dataItem)} title="Edit Question" />
            <Button icon="delete" onClick={() => props.remove(dataItem)} title="Delete Question" />
        </td>
    )
}

const EditInductionPlaylists = () => {
    const { id } = useParams(); // editroles/id url is used to edit existing role, otherwise id is undefined
    const saveName = id === undefined ? "Create" : "Update";
    const [formkey, setFormkey] = React.useState(0); // seems to be needed to push values to form after loading
    const [question, setQuestion] = React.useState('');
    const [a1, setA1] = React.useState('');
    const [a2, setA2] = React.useState('');
    const [a3, setA3] = React.useState('');
    const [a4, setA4] = React.useState('');
    const [a5, setA5] = React.useState('');
    const [correct, setCorrect] = React.useState();
    const [image, setImage] = React.useState("");
    const [data, setData] = React.useState([]);
    const [permissions, setPermissions] = React.useState(null);
    const [sites, setSites] = React.useState([]);
    const [questions, setQuestions] = React.useState([]);
    const progressRef = React.useRef({});
    const [selectedQuestion, setSelectedQuestion] = React.useState(0);
    const [uploadMessage, setUploadMessage] = React.useState("");
    const navigate = useNavigate();
    const selectedItem = React.useRef();
    const [lookupParams, setLookupParams] = React.useState("");
    const [submitDisabled, setSubmitDisabled] = React.useState(false);
    let dt = new Date();
    let dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: null };
    const [dateRange, setDateRange] = React.useState(dr);
    const [expandedPanels, setExpandedPanels] = useState({
        playlistDetails: true,
        playlistQuestions: false,
        testPlaylist: false,
        results: false
    });

    const togglePanel = (panel) => {
        setExpandedPanels(prev => ({ ...prev, [panel]: !prev[panel] }));
    };

    const [columns, setColumns] = React.useState([
        { field: 'driver', label: 'Truck/Driver', type: 'text', format: null, isVisible: true },
        { field: 'lastCorrect', label: 'Number Correct', type: 'numeric', format: null, isVisible: true },
        { field: 'lastWrong', label: 'Number Wrong', type: 'numeric', format: null, isVisible: true },
        { field: 'lastCompleted', label: 'Test Time', type: 'date', format: '{0:d/MM/yy hh:mm}', isVisible: true },
        { field: 'lastAnswers', label: 'Last Answers', type: 'text', format: null, isVisible: true },
    ]);
    const answers = ['1', '2', '3', '4', '5'];
    const [layout, setLayout] = React.useState([
        { "field": "startDate", "label": "Start Date", "defaultValue": new Date(), "isVisible": true, "type": "datetime" },
        { "field": "repeatPeriod", "label": "Repeat Period (days)", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "correctAnswerMessage", "label": "Correct Answer Message", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "wrongAnswerMessage", "label": "Wrong Answer Message", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "isActive", "label": "Active", "defaultValue": true, "isVisible": true, "type": "boolean" },
        { "field": "displayOrder", "label": "DisplayOrder", "defaultValue": 1, "isVisible": true, "type": "numeric" },
        { "field": "mandatory", "label": "Must answer correctly", "defaultValue": true, "isVisible": true, "type": "boolean" },
        { "field": "randomize", "label": "Randomize answer order", "defaultValue": true, "isVisible": true, "type": "boolean" },
        { "field": "siteId", "label": "Site", "defaultValue": 1, "isVisible": true, "type": "numeric" },
        { "field": "playlistDetails", "label": "Details", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "playlistQuestions", "label": "Questions", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "question", "label": "Question", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "uploadImage", "label": "Upload Image", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "answer1", "label": "Answer 1", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "answer2", "label": "Answer 2", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "answer3", "label": "Answer 3", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "answer4", "label": "Answer 4", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "answer5", "label": "Answer 5", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "correctAnswer", "label": "Correct Answer", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "addQuestion", "label": "Add Question", "defaultValue": "", "isVisible": true, "type": "text" },
    ]);

    // Gets field from layout based on field name
    const GetField = (f) => {
        return layout.find(obj => { return obj.field === f });
    }

    // State data for form. Values match form value on submit
    const [values, setValues] = React.useState({
        startDate: GetField("startDate")["defaultValue"],
        displayOrder: GetField("displayOrder")["defaultValue"],
        repeatPeriod: GetField("repeatPeriod")["defaultValue"],
        correctAnswerMessage: GetField("correctAnswerMessage")["defaultValue"],
        wrongAnswerMessage: GetField("wrongAnswerMessage")["defaultValue"],
        mandatory: GetField("mandatory")["defaultValue"],
        randomize: GetField("randomize")["defaultValue"],
        siteId: GetField("siteId")["defaultValue"],
        isActive: String(GetField("isActive")["defaultValue"]).toLowerCase() === "true"
    });

    // When page first loads:
    // - populate drop downs from api/options
    // - if in edit mode, set initial values for all fields for api/drivers
    React.useEffect(() => {
        GetPermissions(["ViewInductionPlaylists", "NewInductionPlaylists", "EditInductionPlaylists", "DeleteInductionPlaylists", "ReportInductionPlaylists"], setPermissions);
        var url = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'editInductionPlaylists'";
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => response.json()).then(d => {
            if (GetSession().IsMobile) {
                let data = [];
                for (let i = 0; i < d.length; i++) {
                    data.push({ field: d[i].field, label: d[i].label, type: d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile });
                }
                setLayout(data);
            } else {
                setLayout(d);
            }
        });
        url = configData.SERVER_URL + "apiv7/options";
        fetch(url, init).then(response => response.json()).then(opt => {
            setSites(opt.sites);
            if (id !== undefined) {
                url = `${configData.SERVER_URL}apiv7/inductionplaylists/${id}`;
                fetch(url, init).then(response => response.json()).then(d => {
                    let dt = d.startDate === null || d.startDate == undefined ? new Date() : new Date(d.startDate + "Z");
                    let st = opt.sites.find(obj => obj.id === String(d.siteId));
                    setQuestions(d.questions);
                    setValues({
                        startDate: dt,
                        repeatPeriod: d.repeatPeriod,
                        correctAnswerMessage: d.correctAnswerMessage,
                        wrongAnswerMessage: d.wrongAnswerMessage,
                        mandatory: d.mandatory,
                        randomize: d.randomize,
                        siteId: st,
                        displayOrder: d.displayOrder === null ? 1 : d.displayOrder,
                        isActive: d.isActive
                    });
                    setFormkey(formkey + 1);
                    UpdateTable();
                })
            }
        });
    }, []);

    // Returns value to be sent to web api:
    // If field is visible just return f
    // If field is hidden, return defaultValue from layout data
    const GetDefaultData = (f, name) => {
        let fld = GetField(name);
        if (fld === undefined || fld === null) return f;
        if (fld["isVisible"]) return f;
        let res = "";
        switch (fld["type"]) {
            case "text": res = fld["defaultValue"]; break;
            case "numeric": res = parseFloat(fld["defaultValue"]); break;
            case "boolean": res = fld["defaultValue"] === "true"; break;
            default: res = fld["defaultValue"]; break;
        }
        return res;
    }

    // Handle submit button. For create POST the data, for edit PUT the data, then redirect to offenses index page.
    const handleSubmit = () => {
        let dataItem = { ...values };
        var pth = id === undefined ? "" : "/" + id;
        var st = GetDefaultData(dataItem.siteId, "siteId");
        if (st !== undefined && st.id !== undefined) st = parseInt(st.id);
        setSubmitDisabled(true);
        var url = `${configData.SERVER_URL}apiv7/inductionplaylists${pth}`;
        const init = {
            method: id === undefined ? 'POST' : 'PUT',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "inductionPlaylistId": id === undefined ? 0 : parseInt(id),
                "displayOrder": GetDefaultData(dataItem.displayOrder, "displayOrder"),
                "startDate": GetDefaultData(dataItem.startDate, "startDate"),
                "siteId": st,
                "repeatPeriod": GetDefaultData(dataItem.repeatPeriod, "repeatPeriod"),
                "correctAnswerMessage": GetDefaultData(dataItem.correctAnswerMessage, "correctAnswerMessage"),
                "wrongAnswerMessage": GetDefaultData(dataItem.wrongAnswerMessage, "wrongAnswerMessage"),
                "mandatory": GetDefaultData(dataItem.mandatory, "mandatory"),
                "randomize": GetDefaultData(dataItem.randomize, "randomize"),
                "isActive": GetDefaultData(dataItem.isActive, "isActive")
            })
        }
        fetch(url, init).then(response => {
            Redirect(msg);
            if (response.status === 200) return response.json();
            var msg = id === undefined ? "New playlist created" : "Playlist updated";
            setSubmitDisabled(false);
        }).then(d => {
            if (id === undefined && d.inductionPlaylistId !== undefined) {
                navigate(`/editinductionplaylists/${d.inductionPlaylistId}`, { state: { msg: msg } });
            } else {
                var msg = id === undefined ? "New playlist created" : "Playlist updated";
                Redirect(msg);
            }
        });
    }

    // navigation
    const GoBack = () => Redirect("");
    const Redirect = (msg = "") => {
        navigate("/inductionplaylists", { state: { msg: msg } });
    }
    if (permissions && !permissions.CanView) navigate("/error401");;
    if (permissions && !permissions.CanEdit && id !== undefined) navigate("/error401");;
    if (permissions && !permissions.CanCreate && id === undefined) navigate("/error401");;

    const UpdateTable = () => {
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        let url = `${configData.SERVER_URL}apiv7/inductionplaylists/${id}`;
        fetch(url, init).then(response => response.json()).then(d => {
            setQuestions(d.questions);
        })
    }

    // form validators
    const textValidator = (value) => !value ? "Please enter a value" : "";

    const ActionCell = (props) => {
        return (<CommandCell {...props} moveUp={MoveUp} moveDown={MoveDown} remove={Remove} edit={EditQuestion} />)
    }

    const ActiveCell = (props) => {
        let d = props.dataItem;
        return (<td><input className="k-checkbox k-checkbox-md k-rounded-md" type="checkbox" checked={d.isActive} onClick={() => ChangeActive(d)} /></td>)
    }

    const ImageCell = (props) => {
        let d = props.dataItem;
        if (d.questionImage !== undefined && d.questionImage.indexOf("data:image") === 0)
            return (<td><img src={d.questionImage} style={{ maxWidth: "150px", maxHeight: "80px" }} /></td>);
        else
            return (<td></td>);
    }

    const MoveUp = (itm) => {
        MessageCommand(itm, "MoveUp");
    }

    const MoveDown = (itm) => {
        MessageCommand(itm, "MoveDown");
    }

    const Remove = (itm) => {
        MessageCommand(itm, "Delete");
    }

    const ChangeActive = (itm) => {
        MessageCommand(itm, "Active");
    }

    const EditQuestion = (itm) => {
        selectedItem.current = itm;
        setSelectedQuestion(itm.inductionQuestionId);
        setQuestion(itm.questionText);
        setImage(itm.questionImage);
        setA1(itm.answer1);
        setA2(itm.answer2);
        setA3(itm.answer3);
        setA4(itm.answer4);
        setA5(itm.answer5);
        setCorrect(String(itm.correctAnswer));
    }

    const MessageCommand = (itm, cmd) => {
        const init = {
            method: 'PATCH',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        let url = `${configData.SERVER_URL}apiv7/inductionquestions?cmd=${cmd}&id=${itm.inductionQuestionId}`;
        fetch(url, init).then(response => {
            UpdateTable();
        })
    }

    const questionChanged = (e) => { setQuestion(e.value) }
    const a1Changed = (e) => { setA1(e.value) }
    const a2Changed = (e) => { setA2(e.value) }
    const a3Changed = (e) => { setA3(e.value) }
    const a4Changed = (e) => { setA4(e.value) }
    const a5Changed = (e) => { setA5(e.value) }
    const correctChanged = (e) => { setCorrect(e.value) }

    const AddQuestion = () => {
        const init = {
            method: selectedQuestion === 0 ? 'POST' : "PUT",
            accept: 'application/json',
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            body: JSON.stringify({
                inductionQuestionId: selectedItem.current == undefined ? 0 : selectedItem.current.inductionQuestionId,
                displayOrder: selectedItem.current == undefined ? 1 : selectedItem.current.displayOrder,
                isActive: selectedItem.current == undefined ? true : selectedItem.current.isActive,
                inductionPlaylistId: id,
                questionText: question,
                questionImage: image,
                answer1: a1,
                answer2: a2,
                answer3: a3,
                answer4: a4,
                answer5: a5,
                correctAnswer: correct === "" ? 1 : correct
            })
        }
        let ext = selectedQuestion === 0 ? "" : `/${selectedQuestion}`
        let url = `${configData.SERVER_URL}apiv7/inductionquestions${ext}`;
        fetch(url, init).then(response => {
            UpdateTable();
            ClearMessage();
        })
    }

    const ClearMessage = () => {
        setSelectedQuestion(0);
        setImage("");
        setQuestion("");
        setA1("");
        setA2("");
        setA3("");
        setA4("");
        setA5("");
        setCorrect("");
        setUploadMessage("");
        selectedItem.current = undefined;

    }

    const onSave = (files, o, onProgress) => {
        const currentFile = files[0];
        const uid = currentFile.uid;
        progressRef.current[uid] = 0;
        files.push(currentFile);

        // Simulate save request
        return new Promise((resolve, reject) => {
            if (currentFile.validationErrors && currentFile.validationErrors.length > 0) {
                reject({ uid: uid });
            } else {
                const reader = new FileReader();
                reader.onload = () => {
                    if (reader.result && typeof reader.result === 'string') {
                        setImage(reader.result);
                        setUploadMessage("Uploaded");
                        resolve({ uid: uid });
                    } else {
                        reject({ uid: uid });
                    }
                };
                reader.onprogress = (data) => {
                    onProgress(uid, data);
                };
                reader.onabort = () => {
                    reject({ uid: uid });
                };
                reader.onerror = () => {
                    reject({ uid: uid });
                };

                reader.readAsDataURL(currentFile.getRawFile());
            }
        });
    }

    const rangeChanged = (event) => {
        let dr = event.target.value;
        setDateRange(dr.value);
        var params = {
            FromDate: dr.start === null ? "2000-01-01T00:00:00Z" : dr.start.toISOString(),
            ToDate: dr.end === null ? "2050-01-01T00:00:00Z" : dr.end.toISOString()
        };
        setLookupParams(encodeURI(JSON.stringify(params)));
    }

    const TestComplete = () => {
        alert("Playlist complete");
    }

    const DateChanged = (e) => { let v = { ...values }; v.startDate = e.value; setValues(v) }
    const RepeatChanged = (e) => { let v = { ...values }; v.repeatPeriod = e.value; setValues(v) }
    const OrderChanged = (e) => { let v = { ...values }; v.displayOrder = e.value; setValues(v) }
    const SiteChanged = (e) => { let v = { ...values }; v.siteId = e.value; setValues(v) }
    const CorrectChanged = (e) => { let v = { ...values }; v.correctAnswerMessage = e.value; setValues(v) }
    const WrongChanged = (e) => { let v = { ...values }; v.wrongAnswerMessage = e.value; setValues(v) }
    const ActiveChanged = (e) => { let v = { ...values }; v.isActive = e.value; setValues(v) }
    const MandatoryChanged = (e) => { let v = { ...values }; v.mandatory = e.value; setValues(v) }
    const RandomizeChanged = (e) => { let v = { ...values }; v.randomize = e.value; setValues(v) }

    return (
        <div style={{ padding: 20, maxWidth: 1200, margin: "auto" }}>
            {GetField("playlistDetails")["isVisible"] && <ExpansionPanel title={GetField("playlistDetails")["label"]} expanded={expandedPanels.playlistDetails} onToggle={() => togglePanel("playlistDetails")}>
                    <Form initialValues={values} key={formkey} render={(formRenderProps) => (
                        <FormElement style={{ width: "98%" }}>
                            <fieldset className={"k-form-fieldset"}>
                                <div className="row">
                                    {GetField("startDate")["isVisible"] && <div className='col-md-2'>
                                        <Field id={"startDate"} name={"startDate"} label={GetField("startDate")["label"]} component={FormDatePicker} onChange={DateChanged} />
                                    </div>}
                                    {GetField("repeatPeriod")["isVisible"] && <div className='col-md-2'>
                                        <Field id={"repeatPeriod"} name={"repeatPeriod"} label={GetField("repeatPeriod")["label"]} component={FormNumericTextBox} min={0} onChange={RepeatChanged} />
                                    </div>}
                                    {GetField("displayOrder")["isVisible"] && <div className="col-md-2">
                                        <Field id={"displayOrder"} name={"displayOrder"} label={GetField("displayOrder")["label"]} component={FormNumericTextBox} validator={textValidator} min={0} onChange={OrderChanged} />
                                    </div>}
                                    {GetField("siteId")["isVisible"] && <div className='col-md-2'>
                                        <Field id={"siteId"} name={"siteId"} label={GetField("siteId")["label"]} component={FormDropDownList} data={sites} textField={"name"} onChange={SiteChanged} />
                                    </div>}
                                </div>
                                <div className="row">
                                    {GetField("correctAnswerMessage")["isVisible"] && <div className="col-md-12">
                                        <Field id={"correctAnswerMessage"} name={"correctAnswerMessage"} label={GetField("correctAnswerMessage")["label"]} component={FormInput} onChange={CorrectChanged} />
                                    </div>}
                                </div>
                                <div className="row">
                                    {GetField("wrongAnswerMessage")["isVisible"] && <div className="col-md-12">
                                        <Field id={"wrongAnswerMessage"} name={"wrongAnswerMessage"} label={GetField("wrongAnswerMessage")["label"]} component={FormInput} onChange={WrongChanged} />
                                    </div>}
                                </div>
                                <div className="row">
                                    {GetField("isActive")["isVisible"] && <div className='col-md-3'>
                                        <Field id={"isActive"} name={"isActive"} label={GetField("isActive")["label"]} component={FormSwitch} onChange={ActiveChanged} />
                                    </div>}
                                    {GetField("mandatory")["isVisible"] && <div className='col-md-3'>
                                        <Field id={"mandatory"} name={"mandatory"} label={GetField("mandatory")["label"]} component={FormSwitch} onChange={MandatoryChanged} />
                                    </div>}
                                    {GetField("randomize")["isVisible"] && <div className='col-md-3'>
                                        <Field id={"randomize"} name={"randomize"} label={GetField("randomize")["label"]} component={FormSwitch} onChange={RandomizeChanged} />
                                    </div>}
                                </div>
                            </fieldset>
                            <div className="k-form-buttons" style={{ paddingTop: 10 }}>
                                <div className='col-md-1'>
                                <Button themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={handleSubmit} disabled={submitDisabled}>{saveName}</Button>
                                </div>
                                <div className='col-md-1'>
                                    <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={GoBack}>Back to List</Button>
                                </div>
                            </div>
                        </FormElement>
                    )} />
                </ExpansionPanel>}
            {GetField("question")["isVisible"] && id !== undefined && <ExpansionPanel title={GetField("playlistQuestions")["label"]} expanded={expandedPanels.playlistQuestions} onToggle={() => togglePanel("playlistQuestions")}>
                    {GetField("question")["isVisible"] && <div className='row' style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>
                            <Label>{GetField("question")["label"]}</Label>
                        </div>
                        <div className='col-md-11'>
                            <TextBox placeholder="Enter question text" value={question} onChange={questionChanged}></TextBox>
                        </div>
                    </div>}
                    {GetField("uploadImage")["isVisible"] && <div className='row' style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>{GetField("uploadImage")["label"]}</div>
                        <div className='col-md-6'>
                            <Upload multiple={false} saveUrl={onSave} />
                        </div>
                        <div className='row' style={{ padding: "10px 20px", color: "red" }}>
                            <div>{uploadMessage}</div>
                        </div>
                    </div>}
                    {GetField("answer1")["isVisible"] && <div className='row' style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>
                            <Label>{GetField("answer1")["label"]}</Label>
                        </div>
                        <div className='col-md-11'>
                            <TextBox placeholder="Enter Answer 1" value={a1} onChange={a1Changed}></TextBox>
                        </div>
                    </div>}
                    {GetField("answer2")["isVisible"] && <div className='row' style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>
                            <Label>{GetField("answer2")["label"]}</Label>
                        </div>
                        <div className='col-md-11'>
                            <TextBox placeholder="Enter Answer 2" value={a2} onChange={a2Changed}></TextBox>
                        </div>
                    </div>}
                    {GetField("answer3")["isVisible"] && <div className='row' style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>
                            <Label>{GetField("answer3")["label"]}</Label>
                        </div>
                        <div className='col-md-11'>
                            <TextBox placeholder="Enter Answer 3" value={a3} onChange={a3Changed}></TextBox>
                        </div>
                    </div>}
                    {GetField("answer4")["isVisible"] && <div className='row' style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>
                            <Label>{GetField("answer4")["label"]}</Label>
                        </div>
                        <div className='col-md-11'>
                            <TextBox placeholder="Enter Answer 4" value={a4} onChange={a4Changed}></TextBox>
                        </div>
                    </div>}
                    {GetField("answer5")["isVisible"] && <div className='row' style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>
                            <Label>{GetField("answer5")["label"]}</Label>
                        </div>
                        <div className='col-md-11'>
                            <TextBox placeholder="Enter Answer 5" value={a5} onChange={a5Changed}></TextBox>
                        </div>
                    </div>}
                    {GetField("correctAnswer")["isVisible"] && <div className='row' style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>
                            <Label>{GetField("correctAnswer")["label"]}</Label>
                        </div>
                        <div className='col-md-2'>
                            <DropDownList data={answers} value={correct} onChange={correctChanged} />
                        </div>
                    </div>}

                    <div className="k-form-buttons" style={{ padding: "10px 0px" }}>
                        <div className='col-md-1'>
                            <Button themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={ClearMessage}>Clear</Button>
                        </div>
                        <div className='col-md-1'>
                            <Button themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={AddQuestion}>{selectedQuestion > 0 ? "Update" : GetField("addQuestion")["label"]}</Button>
                        </div>
                    </div>
                    <Grid data={questions} >
                        <GridColumn field="questionText" title="Question" />
                        <GridColumn field="questionImage" title="Image" cells={{ data: ImageCell }} />
                        <GridColumn field="answer1" title="Answer 1" />
                        <GridColumn field="answer2" title="Answer 2" />
                        <GridColumn field="answer3" title="Answer 3" />
                        <GridColumn field="answer4" title="Answer 4" />
                        <GridColumn field="answer5" title="Answer 5" />
                        <GridColumn field="isActive" title="Active" width="70px" cells={{ data: ActiveCell }} />
                        <GridColumn field="displayOrder" title="Display Order" width="100px" />
                        <GridColumn field="action" title="Action" cells={{ data: ActionCell }} width="150px" />
                    </Grid>
            </ExpansionPanel>}
            {id !== undefined && <ExpansionPanel title="Test Playlist" expanded={expandedPanels.testPlaylist} onToggle={() => togglePanel("testPlaylist")}>
                    <Induction playlist={id} rego="Testing" finished={TestComplete} />
            </ExpansionPanel>}
            {id !== undefined && <ExpansionPanel title="Results" expanded={expandedPanels.results} onToggle={() => togglePanel("results")}>
                    <div className="col-md-4">
                        <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged} />
                    </div>
                    {permissions && <DataGrid dataSource='apiv7/inductionresults' columns={columns} permissions={permissions} params={lookupParams} keyField="inductionResultId" />}
            </ExpansionPanel>}
        </div>
    );
}

export default EditInductionPlaylists